import axios from "axios";
import { getTokenFromCookies } from "../utils";

const token = getTokenFromCookies();
const api = axios.create({
  baseURL: process.env?.REACT_APP_BACKEND_URL,
  headers: {
    Authorization : `Bearer ${token}`,
    "ngrok-skip-browser-warning": process.env.NODE_ENV === 'development' 
      ? "DEVELOPMENT" 
      : undefined
  }
});

// Enhanced request interceptor
api.interceptors.request.use((config) => {
    const token = getTokenFromCookies();
  // Add debug logging
  
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn('No JWT token found in cookies');
  }
  
  // Ensure proper header casing
  if (config.headers?.authorization) {
    config.headers.Authorization = config.headers.authorization;
    delete config.headers.authorization;
  }
  
  return config;
}, (error) => {
  console.error('Request interceptor error:', error);
  return Promise.reject(error);
});

export default api;